<template>
  <tg-button :class="classes" round :disabled="num == 0">{{$t('component.btn.trial', {num: num})}}</tg-button>
</template>

<script>
import TgButton from "@/components/button/TgButton";

export default {
  components: {
    TgButton
  },
  computed: {
    classes() {
      return ["tg-trial-btn"];
    }
  },
  props: {
    num: Number
  }
};
</script>